import { render, staticRenderFns } from "./CbsInlineArgument.vue?vue&type=template&id=17b97bc7&scoped=true"
import script from "./CbsInlineArgument.vue?vue&type=script&lang=js"
export * from "./CbsInlineArgument.vue?vue&type=script&lang=js"
import style0 from "./CbsInlineArgument.vue?vue&type=style&index=0&id=17b97bc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b97bc7",
  null
  
)

export default component.exports